import {
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  makeStyles,
  Avatar,
  Chip,
} from "@material-ui/core";
import { Error, Business } from "@material-ui/icons";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { OrganisationListState } from "../../redux/state";
import { Organisation } from "../../domain/Organisation";
import {
  OrganisationChange,
  OrganisationChangeStatus,
} from "../../domain/OrganisationChange";
import { UserRole } from "../../domain/userRole";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { authSelector } from "../../redux/selectors";

const useStyles = makeStyles((theme) => ({
  submissionRowDetails: {
    paddingRight: "20px",
  },
  submissionRow: {
    ...theme.list.itemPrimary,
  },
  submissionRowDisabled: {
    ...theme.list.itemDisabled,
  },
  secondaryRow: {
    textAlign: "right",
  },
}));

const ORGANISATION_LIST_SEARCH_STATE_KEY = "organisationsListSearch";

export const OrganisationList: React.FC<{
  orgListState: OrganisationListState;
}> = ({ orgListState }) => {
  const classes = useStyles();

  const { response } = orgListState;
  const { isInRole } = useAuth(authSelector);

  const history = useHistory();
  const { pathname, search } = useLocation();
  const navigate = (id: any) =>
    history.push(`${pathname}/${id}`, {
      [ORGANISATION_LIST_SEARCH_STATE_KEY]: search,
    });

  const hasActiveChanges = (changeList: OrganisationChange[]) => {
    return (
      changeList &&
      changeList.filter(
        (change) => change.status === OrganisationChangeStatus.Active
      ).length > 0
    );
  };

  const canShowPendingChanges = isInRole(
    UserRole.OfqualRegulatoryAdmin,
    UserRole.ITAdmin
  );

  return (
    <Paper>
      <List disablePadding>
        {response.data.map((item: Organisation) => (
          <React.Fragment key={item.id}>
            <ListItem
              button
              alignItems="flex-start"
              onClick={() => navigate(item.itemId ?? null)}
              divider
              data-test="org-row"
              className={classes.submissionRow}
            >
              <ListItemAvatar>
                <Avatar>
                  <Business />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography component="span" variant="h6" color="textPrimary">
                    {item.legalName}
                  </Typography>
                }
                secondary={
                  <React.Fragment>
                    <Typography
                      className={classes.submissionRowDetails}
                      component="span"
                      variant="body2"
                      color="textPrimary"
                    >
                      <strong>Acronym:</strong> {item.acronym}
                    </Typography>
                    <Typography
                      className={classes.submissionRowDetails}
                      component="span"
                      variant="body2"
                      color="textPrimary"
                    >
                      <strong>Legal Name:</strong> {item.legalName}
                    </Typography>
                    <div className={classes.secondaryRow}>
                      {canShowPendingChanges &&
                        hasActiveChanges(item.organisationChanges) && (
                          <Chip
                            size="small"
                            data-test="legal-name"
                            label="Pending changes"
                            icon={<Error />}
                            color="primary"
                          />
                        )}
                      {/* TODO figure out why this chip isn't working */}
                      {item.pendingRecognition && (
                        <Chip
                          size="small"
                          label="Pending recognition"
                          icon={<Error />}
                          color="primary"
                        />
                      )}
                    </div>
                  </React.Fragment>
                }
              />
            </ListItem>
          </React.Fragment>
        ))}
      </List>
    </Paper>
  );
};
